import { render, staticRenderFns } from "./CustomersView.vue?vue&type=template&id=9e061164"
import script from "./CustomersView.vue?vue&type=script&lang=ts"
export * from "./CustomersView.vue?vue&type=script&lang=ts"
import style0 from "./CustomersView.vue?vue&type=style&index=0&id=9e061164&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports